import 'babel-polyfill'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VueClipboard from 'vue-clipboard2'
import GAuth from 'vue-google-oauth2'
import VueYandexMetrika from 'vue-yandex-metrika'
import VueMeta from 'vue-meta'

import 'roboto-fontface/css/roboto/roboto-fontface.css'
import { Icon } from 'leaflet'
import { GOOGLE_APP_ID, YANDEX_METRICA_ID } from './utils/auth'
import { SETTINGS_MODULE } from './store/modules'
import { isPrerendered } from './utils/prerender'

Vue.config.productionTip = false

/* leaflet icon configuration */
delete Icon.Default.prototype._getIconUrl

Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

Vue.use(VueClipboard)

Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
})

if (!(isPrerendered())) {
  Vue.use(GAuth, {
    clientId: GOOGLE_APP_ID,
    scope: 'profile email',
    promt: 'select_account',
    fetch_basic_profile: false,
    access_type: 'offline',
    prompt: 'consent'
  })

  if (process.env.NODE_ENV === 'production') {
    Vue.use(VueYandexMetrika, {
      id: YANDEX_METRICA_ID,
      router: router,
      env: process.env.NODE_ENV
    })
  }
}

// set language from store data
vuetify.framework.lang.current = store.state[SETTINGS_MODULE].appLanguage

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
  // mounted () {
  //   document.dispatchEvent(new Event('render-event'))
  // }
}).$mount('#app')
